import * as actionTypes from 'actions/warehouseVideoActions';

const initLinkVideoView = {
  cam1: '',
  cam2: '',
  cam3: '',
  cam4: '',
  cam5: '',
  cam6: ''
};

const initialState = {
  loading: false,
  wayPoints: [],
  markers: [],
  videos: [],
  emails: [],
  linkVideo: [],
  countActive: 0,
  listVideoView: initLinkVideoView,
  listChannel: [],
  loadingEmail: false,
  videoStatistics: {
    total_done: 0,
    total_failed: 0,
    total_size: '0'
  }
};

const warehouseVideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_WAY_POINTS: {
      return {
        ...state,
        wayPoints: action.wayPoints
      };
    }

    case actionTypes.UPDATE_MARKER: {
      return {
        ...state,
        markers: action.marker
      };
    }
    case actionTypes.SET_VIDEOS: {
      return {
        ...state,
        videos: action.videos,
        loading: false
      };
    }

    case actionTypes.SET_EMAILS: {
      return {
        ...state,
        emails: action.emails,
        loadingEmail: false
      };
    }

    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.loading
      };
    }
    case actionTypes.SET_LOADING_EMAIL: {
      return {
        ...state,
        loadingEmail: action.loadingEmail
      };
    }

    case actionTypes.SET_LINK_VIDEO: {
      return {
        ...state,
        linkVideo: action.linkVideo
      };
    }

    case actionTypes.SET_VIEW_VIDEO: {
      const camNumber = state.countActive < 6 ? state.countActive + 1 : 1;
      return {
        ...state,
        listVideoView: {
          ...state.listVideoView,
          ...{
            [`cam${camNumber}`]: action.linkVideo
          }
        },
        countActive: camNumber
      };
    }

    case actionTypes.SET_LIST_CHANNEL: {
      return {
        ...state,
        listChannel: action.listChannel,
        loading: false
      };
    }
    case actionTypes.RESET_VIEW_VIDEO: {
      return {
        ...state,
        listVideoView: initLinkVideoView,
        countActive: 0
      };
    }

    case actionTypes.SET_VIDEO_STATISTICS: {
      return {
        ...state,
        videoStatistics: action.statistics
      };
    }

    default: {
      return state;
    }
  }
};

export default warehouseVideoReducer;
